import { render, staticRenderFns } from "./CustomSvg.vue?vue&type=template&id=1d813fbe"
import script from "./CustomSvg.vue?vue&type=script&lang=js"
export * from "./CustomSvg.vue?vue&type=script&lang=js"
import style0 from "./CustomSvg.vue?vue&type=style&index=0&id=1d813fbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports